import { currentLanguage } from "../../algorithms/storage";
import axios from "../axiosConfig";
export const getAllAssignments = (
  communityID,
  pageNumber,
  pageSize,
  data,
  token,
) => {
  return axios.post(
    `PresidentalTask/Search/${communityID}/${pageNumber}/${pageSize}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
export const addAssignment = (data, token) => {
  return axios.post(`PresidentalTask/AddTask`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const updateAssignment = (data, token) => {
  return axios.post(`PresidentalTask/UpdateTask`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getAssignment = (id, token) => {
  return axios.get(`PresidentalTask/Details/${id}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const deleteAssignment = (data, token) => {
  return axios.post(`Agenda/DeleteAgenda`, data, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

///responces

export const addResponse = (owner, data, token) => {
  return axios.post(
    `PresidentialTaskComment/AddTaskComment?ownerId=${owner}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
export const updateResponse = (data, token) => {
  return axios.post(`Agenda/EditAgenda`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getAllResponse = (id, token) => {
  return axios.get(`PresidentialTaskComment/GetComments/${id}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
